import { Attr, BelongsTo, HasOne, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Employer from "./Employer";
import Job from "./Job";
import Recruiter from "./Recruiter";
import RecruiterUser from "./RecruiterUser";

@Model()
class Feedback extends ApplicationRecord {
  static jsonapiType = "feedbacks";

  @Attr() average: number;

  @Attr() createdAt: string;

  @Attr() engagementId: number;

  @Attr() communication: number;

  @Attr() qualityOfSubmission: number;

  @Attr() speedOfResponse: number;

  @Attr() professionalism: number;

  @Attr() message: string;

  @Attr() status: string;

  @Attr() jobId: number;

  @HasOne(Employer) employer: Employer;

  @BelongsTo(Job) job: Job;

  @BelongsTo(Recruiter) recruiter: Recruiter;

  @BelongsTo(RecruiterUser) recruiterUser: RecruiterUser;
}

export default Feedback;
